import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { FiPackage, FiLayers } from 'react-icons/fi';
import { toast } from 'sonner';
import { productMonitoringApi } from '../config/api';

const LABELS = { twc: 'Destination Management', hin: 'Hospitality', ias: 'Aviation Services', api: 'Airports', retail: 'Retail', itdc: 'Tourism Development', ap: 'Airports' };

export default function PublishedProductsTab({ memberCode }) {
  const [published, setPublished] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const fetch = async () => {
    setLoading(true);
    try {
      const mc = { ap: 'api' }[memberCode] || memberCode;
      const res = await productMonitoringApi.get('/published', { params: { member_code: mc, limit: 100 } });
      if (res.data?.status === 200) { setPublished(res.data.data || []); setTotal(res.data.pagination?.total || 0); }
    } catch { toast.error('Gagal memuat published products.'); }
    finally { setLoading(false); }
  };

  useEffect(() => { if (memberCode) fetch(); }, [memberCode]);

  const label = LABELS[memberCode] || memberCode?.toUpperCase() || '';
  const pkgs = new Set(published.map(p => p.PACKAGE_ID)).size;

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Card className="border-0 bg-white shadow-sm"><CardContent className="p-5"><div className="flex items-center gap-3"><div className="rounded-xl bg-[#EFF6FF] p-3 text-[#2563EB]"><FiPackage className="h-5 w-5" /></div><div><p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Total Published</p><h3 className="text-2xl font-bold text-slate-800">{total}</h3></div></div></CardContent></Card>
        <Card className="border-0 bg-white shadow-sm"><CardContent className="p-5"><div className="flex items-center gap-3"><div className="rounded-xl bg-[#ECFDF5] p-3 text-[#059669]"><FiLayers className="h-5 w-5" /></div><div><p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Packages</p><h3 className="text-2xl font-bold text-slate-800">{pkgs}</h3></div></div></CardContent></Card>
      </div>
      <Card className="border-0 bg-white shadow-sm">
        <div className="p-5 pb-3"><h2 className="text-base font-bold text-slate-700">Published Products — {label}</h2></div>
        <div className="px-5 pb-5">
          {loading ? <p className="py-8 text-center text-slate-400">Memuat...</p>
          : published.length === 0 ? <p className="py-8 text-center text-slate-400">Belum ada produk dipublikasikan untuk {label}.</p>
          : <Table><TableHeader className="bg-slate-50"><TableRow><TableHead className="font-bold">Product</TableHead><TableHead className="font-bold">Category</TableHead><TableHead className="font-bold">Location</TableHead><TableHead className="font-bold">Package</TableHead><TableHead className="font-bold">Published</TableHead></TableRow></TableHeader>
          <TableBody>{published.map((p, i) => (
            <TableRow key={p.PUBLISH_ID || i} className="hover:bg-slate-50/50">
              <TableCell className="font-semibold text-slate-700 text-xs">{p.BPPRODUCT_NAME || 'Unnamed'}</TableCell>
              <TableCell><Badge className="text-[10px] bg-slate-100 text-slate-600 border-0">{p.BPPRODUCT_CATEGORY || 'N/A'}</Badge></TableCell>
              <TableCell className="text-xs text-slate-500">{p.location || '-'}</TableCell>
              <TableCell><span className="font-bold text-slate-800 text-[11px]">{p.PACKAGE_CODE}</span> <span className="text-[10px] text-slate-400">{p.PACKAGE_NAME}</span></TableCell>
              <TableCell className="text-xs text-slate-500">{p.PUBLISHED_AT ? new Date(p.PUBLISHED_AT).toLocaleDateString('id-ID') : '-'}</TableCell>
            </TableRow>
          ))}</TableBody></Table>}
        </div>
      </Card>
    </div>
  );
}
